import { render, staticRenderFns } from "./PlayVideoModal.vue?vue&type=template&id=33964282&scoped=true"
import script from "./PlayVideoModal.vue?vue&type=script&lang=js"
export * from "./PlayVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33964282",
  null
  
)

export default component.exports